import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { AppContext } from '@nile/components';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import { TextStyle } from '@superops/ui-design-system';

function DateTimeCell(props) {
  const { cell, row } = props;
  const appContext = useContext(AppContext);
  const { company } = appContext;

  const value = cell.value
    ? dayjs(cell.value).format(
        `${company?.dateFormat || 'MMM DD YYYY'}, ${company?.timeFormat ||
          'hh:mm A'}`
      )
    : '';

  const field = cell?.column?.field || {};

  return value ? (
    <CellWrapper>
      <div className="ellipsis" title={value}>
        <TextStyle
          variation={
            cell.column?.customTextStyles &&
            field.name === 'dueDate' &&
            row.original.overdue
              ? 'negative'
              : ''
          }
        >
          {value}
        </TextStyle>
      </div>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default DateTimeCell;
